<template>
  <AppButton class="crop-calculator__download-btn adjust-padding" icon="DownloadIcon" @click="handleClickPrint()">
    Generate Report
  </AppButton>
</template>

<script>
import AppButton from '@/components/shared/AppButton';

import html2pdf from 'html2pdf.js';

export default {
  components: {
    AppButton
  },
  props: {
    fileName: {
      type: String,
      default: 'Yield Calculator Results'
    },
    generateCallback: {
      type: Function,
      default: null
    }
  },
  inject: ['getPdfEl'],
  computed: {
    pdfEl() {
      return this.getPdfEl();
    }
  },
  methods: {
    handleClickPrint() {
      const pdfOptions = {
        filename: this.fileName,
        image: {
          type: 'png',
          quality: 1
        },
        html2canvas: {
          dpi: 192,
          letterRendering: true,
          scale: 2,
          useCORS: true
        },
        jsPDF: {
          format: 'legal',
          orientation: 'portrait'
        },
        margin: 0
      };

      const printableElementClone = this.pdfEl.cloneNode(true);
      printableElementClone.classList.add('pdf');

      if (this.generateCallback !== null) {
        this.generateCallback();
      }

      // Choose the clonedElement and save the PDF for our user.
      html2pdf()
        .set(pdfOptions)
        .from(printableElementClone)
        .save();

      printableElementClone.remove();
      
    }
  }
};
</script>

<style scoped>
.download-btn {
  margin-block: spacing('sm');
}
</style>
